'use client';
import { CIInfoIcon } from 'car-insurance/components/common';
import { useBreakpoint } from 'car-insurance/hooks/useBreakpoint';
import { ProductBadge } from 'car-insurance/types';
import classNames from 'classnames';

export interface BadgeProps {
  badge: ProductBadge;
  withoutDetails?: boolean;
}

export const Badge: React.FC<BadgeProps> = ({
  badge,
  withoutDetails = false,
}) => {
  const { text, color, show_details } = badge;
  const activeBreakpoint = useBreakpoint();
  const isMobileBreakpoint =
    activeBreakpoint === 'sm' || activeBreakpoint === 'md';

  return (
    <div
      className={classNames(
        'w-fit max-w-full flex gap-1 items-center font-medium capitalize xl:text-base lg:text-base md:text-sm sm:text-sm px-2 py-0.5 rounded-3xl text-gray-800 bg-gray-100 border border-gray-100 justify-between',
        {
          'bg-green-50 border-green-50 text-light-green-900': color === 'green',
        },
        {
          'bg-light-blue-50 border-light-blue-50 text-light-blue-900':
            color === 'blue',
        },
        {
          '!border-light-green-300 !pr-1': show_details && !withoutDetails,
        },
      )}
      role="button"
      tabIndex={0}
    >
      <span
        className={classNames('alpha-tag', { truncate: isMobileBreakpoint })}
      >
        {text}
      </span>
      {show_details && !withoutDetails && (
        <CIInfoIcon size={isMobileBreakpoint ? 16 : 18} color="#33691E" />
      )}
    </div>
  );
};
